import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { useLang } from "@/i18n/LanguageContext";

// Floating pill CTA to take the quiz. Appears on all pages except /quiz and /.
// Shows after user scrolls past hero on Breeds/BreedProfile.
export default function FloatingQuizCTA() {
    const location = useLocation();
    const [visible, setVisible] = useState(false);
    const { t } = useLang();

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 500);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // Hide on quiz page itself and home
    if (location.pathname === "/quiz" || location.pathname === "/") return null;

    return (
        <Link
            to="/quiz"
            data-testid="floating-quiz-cta"
            className={`fixed bottom-6 right-6 z-40 group inline-flex items-center gap-3 bg-ink text-paper pl-4 pr-6 py-3 rounded-full shadow-lift transition-all duration-500 ease-editorial hover:bg-gold hover:text-ink ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
            }`}
        >
            <span className="relative flex items-center justify-center w-8 h-8 rounded-full bg-gold/20 group-hover:bg-ink/10 transition-colors">
                <Sparkles size={14} strokeWidth={1.5} className="text-gold group-hover:text-ink" />
            </span>
            <span className="flex flex-col leading-tight">
                <span className="text-[10px] uppercase tracking-widest opacity-70">{t("floatingQuiz.label")}</span>
                <span className="text-sm font-medium">{t("quiz.introTitle")}</span>
            </span>
            <ArrowRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
    );
}
